import { NOTIFICATIONS } from 'Config/Paths';
import { UserNotification } from 'Models/Notification';
import { ResponseModel } from 'Models/ResponseModel';
import { restApiGet } from 'RestApiConnector';

import { NotificationsApi } from './NotificationsApi';

export class AWSNotificationsApi implements NotificationsApi {
    /** A User retrieves Notifications for themselves. */
    getNotificationsSelf = (startTime?: string, endTime?: string): Promise<ResponseModel<UserNotification[]>> => {
        const queryParameters = {
            start_time: startTime,
            end_time: endTime,
        };
        return restApiGet(`/${NOTIFICATIONS}`, queryParameters);
    };

    /** A User retrieves Notifications for someone else.  */
    getNotificationsOther = (userId: string, startTime?: string, endTime?: string): Promise<ResponseModel<UserNotification[]>> => {
        const queryParameters = {
            start_time: startTime,
            end_time: endTime,
        };
        return restApiGet(`/${NOTIFICATIONS}/${userId}`, queryParameters);
    };
}
